import React from 'react';
import { ChefHatIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const highlights = ['40 recetas con costo por pieza', '6 menús para 10, 20 y 30 personas', 'Plan de 30 días', '5 bonos'];
export function SystemIntro() {
  return <section className="w-full bg-sand pb-12 pt-16 sm:pb-16 sm:pt-24" aria-labelledby="sistema-title" data-id="element-207" data-mp="239f0biiv4fpr">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-208" data-mp="2876s8cjic1ty">
        <Reveal data-id="element-209" data-mp="1bihd2tz9lnbo">
          <p className="mx-auto inline-flex max-w-full items-start gap-2 rounded-2xl bg-cream px-3.5 py-2 text-left text-sm font-medium text-mint-700 ring-1 ring-inset ring-cream-line sm:items-center sm:rounded-full" data-id="element-210" data-mp="1bj0tg699o3nl">
            <ChefHatIcon className="mt-0.5 h-4 w-4 shrink-0 sm:mt-0" aria-hidden="true" data-id="element-211" data-mp="1kh2s4f5j2k7p" />
            <span data-id="element-212" data-mp="1pj1tjjhpj720">Pensado para cocinas de casa en México</span>
          </p>
          <h2 id="sistema-title" className="mt-6 font-display text-3xl leading-[1.1] text-ink sm:text-5xl" data-id="element-213" data-mp="2vwhn5de6f206">
            Catering para Emprender
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-214" data-mp="15infpb35jf6n">
            Todas las piezas se conectan con un mismo sistema de códigos: cada receta (R01 a R40) alimenta los menús (M1 a M6), y cada menú tiene su lista de compras, su cronograma y su costeo. Si sube un ingrediente, lo cambias una sola vez en tu hoja de costeo.
          </p>
          <ul className="mx-auto mt-8 flex max-w-2xl flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-215" data-mp="ricrkft88ep6">
            {highlights.map(item => <li key={item} className="text-sm font-medium text-mint-700" data-id="element-216" data-mp="mlm9jmxv3914">
                {item}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}